<app-layout>
  <app-voltar route="listagem/funcionario" />
  <div class="headerForm">
    <div class="title">
      <app-titulo>{{ title }}</app-titulo>
    </div>
    <div class="espacamento"></div>
  </div>

  <div class="forms">
    <form [formGroup]="form">
      <div class="formList">
        <app-input
          label="Nome Completo"
          name="NM_FUNC"
          formControlName="NM_FUNC"
          placeholder="Digite aqui"
          maxLength="40"
          [requiredInput]="true"
          [disabled]="statusInput"></app-input>

        <app-input
          label="CPF"
          name="TX_CPF_FUNC"
          formControlName="TX_CPF_FUNC"
          placeholder="Digite aqui"
          mask="000.000.000-00"
          placeholder="___.___.___-__"
          [disabled]="statusInput"></app-input>

        <app-input
          type="email"
          label="E-mail"
          name="TX_MAIL_FUNC"
          formControlName="TX_MAIL_FUNC"
          placeholder="Digite aqui"
          maxLength="50"
          [requiredInput]="true"
          [disabled]="statusInput"></app-input>

        <app-input
          label="E-Social"
          name="NU_RGST"
          formControlName="NU_RGST"
          placeholder="Digite aqui"
          type="text"
          [requiredInput]="true"
          [disabled]="statusInput"></app-input>

        <app-input
          label="PIS/PASEP"
          name="NU_PIS_PASEP"
          formControlName="NU_PIS_PASEP"
          placeholder="Digite aqui"
          type="text"
          maxLength="11"
          [disabled]="statusInput"></app-input>

        <app-input
          label="Telefone"
          name="TX_TELE_FUNC"
          formControlName="TX_TELE_FUNC"
          placeholder="Digite aqui"
          mask="(00) 00000-0000"
          placeholder="(__) _____-____"
          [disabled]="statusInput"></app-input>

        <app-input
          label="CEP"
          name="TX_ENDE_CEP_FUNC"
          formControlName="TX_ENDE_CEP_FUNC"
          placeholder="_____-___"
          mask="00000-000"
          (ngModelChange)="consultaCEP()"
          [disabled]="statusInput"></app-input>

        <app-input
          label="Estado"
          name="TX_ENDE_ESTD_FUNC"
          formControlName="TX_ENDE_ESTD_FUNC"
          placeholder="Digite aqui"
          maxLength="2"
          [disabled]="statusInput"></app-input>

        <app-input
          label="Cidade"
          name="TX_ENDE_CDDE_FUNC"
          formControlName="TX_ENDE_CDDE_FUNC"
          placeholder="Digite aqui"
          maxLength="50"
          [disabled]="statusInput"></app-input>

        <app-input
          label="Endereço"
          name="TX_ENDE_RUA_FUNC"
          formControlName="TX_ENDE_RUA_FUNC"
          placeholder="Digite aqui"
          maxLength="50"
          [disabled]="statusInput"></app-input>

        <app-input
          label="Username"
          name="TX_USER_NAME"
          formControlName="TX_USER_NAME"
          placeholder="Digite aqui"
          maxLength="20"
          [requiredInput]="true"
          [disabled]="statusInput"></app-input>

        <app-input
          type="select"
          label="Perfil"
          name="FK_PERF"
          formControlName="FK_PERF"
          placeholder="Selecione"
          [requiredInput]="true"
          [selectData]="tipoPerfilOptions"
          (ngModelChange)="escolherTipoPerfil($event)"
          [disabled]="statusInput"></app-input>

        <app-input
          type="select"
          label="Turno"
          name="NU_TRNO_FUNC"
          formControlName="NU_TRNO_FUNC"
          placeholder="Selecione"
          [requiredInput]="true"
          [selectData]="turnoOptions"
          [preserveOrder]="true"
          (ngModelChange)="escolherTurno($event)"
          [disabled]="statusInput"></app-input>

        <app-input
          type="password"
          label="Senha"
          name="TX_SENH_FUNC"
          formControlName="TX_SENH_FUNC"
          maxLength="15"
          placeholder="Digite aqui"
          [requiredInput]="!title.includes('Editar')"
          (ngModelChange)="confirmacaoSenha()"
          [disabled]="statusInput"></app-input>

        <app-input
          type="password"
          label="Confirme a senha"
          name="TX_SENH_FUNC_CNFRM"
          formControlName="TX_SENH_FUNC_CNFRM"
          maxLength="15"
          placeholder="Digite aqui"
          [requiredInput]="!title.includes('Editar')"
          (ngModelChange)="confirmacaoSenha()"
          [disabled]="statusInput"></app-input>

        <div
          class="validators"
          *ngIf="this.form.controls['TX_SENH_FUNC'].value.length > 0">
          <p [ngClass]="{ valid: isLengthValid, invalid: !isLengthValid }">
            No mínimo 8 caracteres
          </p>
          <p [ngClass]="{ valid: hasNumber, invalid: !hasNumber }">
            Pelo menos um número
          </p>
          <p [ngClass]="{ valid: hasLowercase, invalid: !hasLowercase }">
            No mínimo 1 caractere minúsculo
          </p>
          <p [ngClass]="{ valid: hasUppercase, invalid: !hasUppercase }">
            No mínimo 1 caractere maiúsculo
          </p>
          <p [ngClass]="{ valid: hasSpecialChar, invalid: !hasSpecialChar }">
            No mínimo 1 caractere especial
          </p>
          <p [ngClass]="{ valid: passwordsMatch, invalid: !passwordsMatch }">
            As senhas devem ser iguais
          </p>
        </div>
      </div>

      <app-botao
        *ngIf="!this.title.includes('Visualizar')"
        class="botao-cadastro"
        type="cadastro"
        [text]="this.isMode() ? 'Cadastrar' : 'Editar'"
        (click)="postarDados()"
        [disabled]="!form.valid"></app-botao>
    </form>
  </div>
  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
